import type { StoreActions } from '../../types';

export const setShouldReopenPanel =
	(shouldReopenPanel: boolean) =>
	({ setState, getState }: StoreActions) =>
		setState({ ...getState(), shouldReopenPanel });
